import { pointerWithin, rectIntersection } from '@dnd-kit/core';

// Custom collision detection method for drag and drop, the pointer is the cleanest solution however it's the most complex
// and may run into issues on mobile. In that case we'll have a fall back algorithm.
export function customCollisionDetectionAlgorithm(args) {
    // First, let's see if there are any collisions with the pointer
    const pointerCollisions = pointerWithin(args);

    // Collision detection algorithms return an array of collisions
    if (pointerCollisions.length > 0) {
        return pointerCollisions;
    }

    // If there are no collisions with the pointer, return rectangle intersections
    return rectIntersection(args);
}
